import {Component, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgbDatepickerModule, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import {catchError, finalize, tap} from 'rxjs/operators';
import {forkJoin, throwError} from 'rxjs';
import {environment} from '../../../environments/environment'

import {BeachesService} from '../beaches.service';
import {DisplayPipe} from '../../../../../shared/src/lib/pipes/display.pipe';
import {BaseService} from '../../../../../shared/src/lib/services/base.service';
import {ToastService} from '../../../../../shared/src/lib/services/toast.service';
import {ErrorHandlingService} from '../../../../../shared/src/lib/services/error-handling.service';
import {GenericModalComponent} from '../../../../../shared/src/lib/modals/generic-modal/generic-modal.component';
import {DynamicModalComponent} from '../../../../../shared/src/lib/modals/dynamic-modal/dynamic-modal.component';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DynamicInputComponent} from '@shared/dynamic-input/dynamic-input.component';
import {DisplayFieldComponent} from '@shared/display-field/display-field.component';

@Component({
    selector: 'app-beach-advisories',
    templateUrl: './beach-advisories.component.html',
    styleUrls: ['./beach-advisories.component.css'],
    providers: [DisplayPipe],
    imports: [
        NgIf,
        FormsModule,
        NgbDatepickerModule,
        NgForOf,
        DynamicInputComponent,
        DisplayPipe,
        DatePipe,
        DisplayFieldComponent
    ]
})
export class BeachAdvisoriesComponent implements OnInit {
  private loadingMore;
  // private monitoringLocationService: BaseService;
  // private monitoringActivityService: BaseService;
  // private observationResultsService: BaseService;
  private criteriaService: BaseService;
  // private advisoryService: BaseService;
  public loading = false;
  public saving = false;
  public criteria;
  public items;
  public meta;
  public item;
  private monitoringLocationChoices: any[];
  private count;
  private searchParams: any;
  private selectedOption: any;
  private calendarOpen: any;
  private hadError: any;
  public showDateSelect = false;
  public startDate;
  public endDate;
  private sampling;
  private searchDate;
  public displayFields;
  private beginSearchDate;
  private endSearchDate;
  private monItems;
  private monActivities;
  public dates = {};
  private times = {};

  constructor(http: HttpClient, public toastr: ToastService, private displayPipe: DisplayPipe,
              private errorHandling: ErrorHandlingService, private modalService: NgbModal,
              public beachService: BeachesService) {
    // this.monitoringActivityService = new BaseService(`${environment.baseUrl}/water_sampling/monitoringactivity`, http);
    // this.observationResultsService = new BaseService(`${environment.baseUrl}/beaches/result`, http);
    this.criteriaService = new BaseService(`${environment.baseUrl}/beaches/criteria`, http);
  }

  ngOnInit() {
    this.dates['actual_startdate'] = null;
    this.dates['actual_stopdate'] = null;
    this.times['actual_stopdate'] = {hour: 0, minute: 0};
    this.times['actual_startdate'] = {hour: 0, minute: 0};
    this.item = {};
    this.startDate = null;
    this.endDate = null;
    this.displayFields = [
      'actual_startdate', 'actual_stopdate', 'type_code', 'activity_reason', 'activity_source', 'activity_indicator'
    ];

  }

  public loadBeaches(code, startDate, endDate) {
    this.loading = true;
    startDate = startDate ? startDate : null;
    endDate = endDate ? endDate : null;
    const queryParams = code === 'all' ? {page_size: 1000} : {}
    this.monitoringLocationChoices = [];
    this.beachService.getList(queryParams).pipe(tap((response) => {
        this.monItems = response.results;
        this.meta = {};
        // this.searchDate = new Date(response.results[0].current.sample_collection_datetime);
        this.monItems.forEach((location) => {
          this.monitoringLocationChoices.push({
            display_name: location.name + ' (' + location.locationid + ')',
            value: location.globalid,
            id: location.locationid
          });
        });
        if (code === 'sampled') {
          this.showDateSelect = false;
          this.sampledActivities();
        } else if (code === 'all') {
          this.items = [];
          this.showDateSelect = false;
          this.beachService.advisoryService.get<any>('metadata').pipe(tap((meta) => {
            this.meta = meta;
            this.meta.display_fields = this.displayFields;
            this.meta.fields.monitoring_location.choices = this.monitoringLocationChoices;
            this.monItems.forEach(monLocation => {
              const item = {
                hasAdvisory: false,
                monitoring_location: monLocation.globalid
              };

              for (const key of Object.keys(this.meta.fields)) {
                const field = this.meta.fields[key];
                if (field.default !== undefined) {
                  this.item[key] = field.default;
                  this.items.forEach(fieldItem => {
                    fieldItem[key] = field.default;
                  });
                }
              }
              this.items.push(item);
            });
          })).subscribe();
        } else if (code === 'missing') {
          this.showDateSelect = true;
          this.searchParams = {
            missing_advisory: 'True',
            sample_collection_datetime_gt: startDate.toISOString(),
            sample_collection_datetime_lt: endDate.toISOString(),
            ordering: 'location_id,sample_collection_datetime',
            page_size: 5000,
            // page: 0
          };
          this.beachService.monitoringActivityService.getList(this.searchParams).pipe(tap((monitoringActivities) => {
            this.count = monitoringActivities.meta.count;
            this.monActivities = monitoringActivities.results;
          })).subscribe(() => {
            this.beachService.advisoryService.get<any>('metadata').pipe(tap((meta) => {
              this.items = [];
              this.meta = meta;
              this.meta.display_fields = this.displayFields;
              this.meta.fields.monitoring_location.choices = this.monitoringLocationChoices;
              this.monActivities.forEach(activity => {
                const currentdate = new Date(activity.sample_collection_datetime);
                const startdate = new Date(currentdate.getFullYear(), currentdate.getMonth(),
                  currentdate.getDate(), 12, 0);
                const stopdate = new Date(currentdate.getFullYear(), currentdate.getMonth(),
                  currentdate.getDate() + 7, 11, 59);

                const item = {
                  hasAdvisory: false,
                  monitoring_location: activity.monitoring_location,
                  actual_startdate: startdate,
                  actual_stopdate: stopdate,
                  sample_date: currentdate,
                  monitoring_activity: activity.globalid
                };

                for (const key of Object.keys(this.meta.fields)) {
                  const field = this.meta.fields[key];
                  if (field.default !== undefined) {
                    item[key] = field.default;
                    this.items.forEach(fieldItem => {
                      fieldItem[key] = field.default;
                    });
                  }
                }
                this.items.push(item);
                this.searchParams.page = 1;
              });
            })).subscribe();
          });
        }
      }),
      finalize(() => {
        this.loading = false;

        // this.loadMore();
      })).subscribe();
  }

  public loadMore() {
    this.loadingMore = true;
    this.searchParams.page += 1;
    this.beachService.monitoringActivityService.getList<any>(this.searchParams).pipe(tap(monitoringActivities => {
        monitoringActivities.results.forEach(activity => {
          const currentdate = new Date(activity.sample_collection_datetime);
          const startdate = new Date(currentdate.getUTCFullYear(), currentdate.getUTCMonth(),
            currentdate.getUTCDate(), 0, 0);
          const stopdate = new Date(currentdate.getUTCFullYear(), currentdate.getUTCMonth(),
            currentdate.getUTCDate() + 7, 23, 59);

          const item = {
            hasAdvisory: false,
            monitoring_location: activity.monitoring_location,
            actual_startdate: startdate,
            actual_stopdate: stopdate
          };

          for (const key of Object.keys(this.meta.fields)) {
            const field = this.meta.fields[key];
            if (field.default !== undefined) {
              this.item[key] = field.default;
              this.items.forEach(fieldItem => {
                fieldItem[key] = field.default;
              });
            }
          }
          this.items.push(item);
        });
      },
      finalize(function () {
        this.loadingMore = false;
      }))).subscribe();
  }

  getBeaches(code, startDate, endDate) {
    this.selectedOption = code;
    if (this.items === undefined) {
      this.loadBeaches(code, startDate, endDate);
    } else {
      const modalInstance = this.modalService.open(GenericModalComponent);
      modalInstance.componentInstance.title = 'Please Confirm';
      modalInstance.componentInstance.text = 'By selecting this you will reload all of the activities and' +
        ' any unsaved changes will be lost.';
      modalInstance.result.then(() => {
        // clear and load beaches
        this.items = [];
        this.loadBeaches(code, startDate, endDate);
      });
    }
  }

  openCalendar(e, key) {
    e.preventDefault();
    e.stopPropagation();
    this.calendarOpen[key] = true;
  }

// openCalendar(item, key, e) {
//     this.meta.verbose_name = 'Select Date '
//     const modalInstance = this.modalService.open(DynamicModalComponent);
//     modalInstance.componentInstance.item = item.sample_collection_datetime;
//     modalInstance.componentInstance.meta = this.meta;
//     e.preventDefault();
//     e.stopPropagation();
//     this.calendarOpen[key] = true;
//
//   }

  applyDate(key, item) {
    if (this.dates[key] === undefined || this.dates[key] === null) {
      this.toastr.warning('Potential date format error. Please check date inputs and try again.');
      // this.saving = false;
    } else {
      const tempDatetime = this.dates[key];
      tempDatetime.setHours(this.times[key].hour);
      tempDatetime.setMinutes(this.times[key].minute);
      item[key] = tempDatetime.formattedDate() + 'T' + tempDatetime.formattedTime() + 'Z';
    }
  }


  applyChange(key, value) {
    this.items.forEach(item => {
      item[key] = value;
      // if ((key === 'actual_startdate' || key === 'actual_stopdate') && value !== undefined) {
      //   this.applyDate(key, item);
      // }
    });
  };

  // private getResults(item) {
  //   this.observationResultsService.getList({search: item.sample_globalid}).subscribe(response => {
  //     // item.measure = response.results.measure;
  //     //  item.geomean = response.results.geomean;
  //   });
  // }

  delete(item) {
    const index = this.items.indexOf(item);
    this.items.splice(index, 1);
  }

  save() {
    const modalInstance = this.modalService.open(GenericModalComponent);
    const observables: any[] = [];
    modalInstance.componentInstance.title = 'Please confirm';
    modalInstance.componentInstance.text = 'Are you sure you are ready to save?';
    modalInstance.result.then(() => {
      this.errorHandling.clearError(this.meta);
      this.errorHandling.customErrorMessage = true;
      this.errorHandling.customSaveMessage = true;
      this.saving = true;
      this.items.map(item => {
        return this.beachService.advisoryService.post(item).pipe(catchError((error: any) => {
          if (error) {
            this.hadError = true;
            return throwError(error);
          } else {
            this.hadError = false;
          }
        })).subscribe(() => {
            this.toastr.success('Succesfully saved sampling activity');
            this.items = undefined;
            this.errorHandling.customErrorMessage = false;
            const index = this.items.indexOf(item);
            this.items.splice(index, 1);
          },
          () => {
            if (this.hadError) {
              this.hadError = false;
              this.toastr.error('Error');
            }
            // switch back to false so it doesn't prevent default error message
            this.errorHandling.customErrorMessage = false;
          });
      });
    });
  }

  open(item, $event) {
    this.meta.verbose_name = 'Advisory Activity for ' +
      this.displayPipe.transform(item.monitoring_location, this.meta.fields.monitoring_location.choices);
    const modalInstance = this.modalService.open(DynamicModalComponent, {size: 'lg'});
    modalInstance.componentInstance.item = item;
    modalInstance.componentInstance.meta = this.meta;
    modalInstance.componentInstance.disableSave = true;
    modalInstance.result.then(i =>
      this.items.forEach(x => {
        if (x.monitoring_location === i.monitoring_location) {
          for (const [key, value] of Object.entries(i)) {
            x[key] = value;
          }
        }
      }));
  }

  // .controller('ModalController', ['this', '$uibModalInstance',
  //     function (this, $uibModalInstance) {
  //         this.ok = function () {
  //             $uibModalInstance.close();
  //         };
  //
  //         this.cancel = function () {
  //             $uibModalInstance.dismiss('cancel');
  //         }
  //     }]);


  private sampledActivities() {
    this.items = [];
    forkJoin({
      sampling: this.beachService.monitoringActivityService.getList<any>({
        page_size: 100,
        missing_results: false,
        ordering: '-sample_collection_datetime',
      }), criteria: this.criteriaService.getList<any>()
    }).subscribe(responses => {
      this.items = [];
      this.sampling = responses.sampling.results;
      this.monItems.forEach((location) => {
        this.monitoringLocationChoices.push({
          display_name: location.name + ' (' + location.locationid + ')',
          value: location.globalid,
          id: location.locationid
        });
        const thisSampling = this.sampling.filter(value => value.monitoring_location === location.globalid);
        let thisCriteria = responses.criteria.results.filter(value => value.monitoring_location === location.globalid);
        if (thisCriteria.length === 0) {
          thisCriteria = responses.criteria.results.filter(value => value.monitoring_location === null);
        }
        thisSampling.forEach((sample, i) => {
          thisSampling[i].advisory = (thisSampling[i].result[0].stv > thisCriteria[0].stv_percent &&
            thisSampling[i].result[0].geometric_mean > thisCriteria[0].geo_criteria);
        });

        this.meta = responses.sampling.meta;
        this.meta.display_fields = this.displayFields;
        this.meta.fields.monitoring_location.choices = this.monitoringLocationChoices;
        if (thisSampling[0].advisory) {
          this.searchDate = moment(thisSampling[0].sample_collection_datetime).add(1, 'day').toISOString();
          this.beachService.advisoryService.getList<any>({
            search: location.globalid,
            actual_startdate_lt: this.searchDate,
            actual_stopdate_gt: this.searchDate
          }).pipe(tap((response) => {
            // this.items = response.results;
            this.meta = response.meta;
            this.meta.display_fields = this.displayFields;
            this.meta.fields.monitoring_location.choices = this.monitoringLocationChoices;

            if (response.results.length === 0) {
              const item = {
                monitoring_location: location.globalid,
                hasAdvisory: false,
                sample_date: thisSampling[0].sample_collection_datetime,
                sample_globalid: thisSampling[0].globalid
              };
              for (const key of Object.keys(this.meta.fields)) {
                const field = this.meta.fields[key];
                if (field.default !== undefined) {
                  this.item[key] = field.default;
                  item[key] = field.default;
                }
              }
              this.items.push(item);
            }
          })).subscribe();
        }
      });
    });
  }

}
